import type { ReactNode } from 'react';
import type { ChakraProps } from '@chakra-ui/react';

import { BaseLayout } from '@izimi/components';
import Nav from 'navigation/Nav';

interface Props extends Omit<ChakraProps, 'transition'> {
  children?: ReactNode;
}

const Layout = ({ children, ...chakraProps }: Props) => {
  return (
    <BaseLayout navigation={<Nav />} {...chakraProps}>
      {children}
    </BaseLayout>
  );
};

export default Layout;
